import {
  call,
  put,
  all,
  takeLeading,
} from 'redux-saga/effects'
import {
  creatListInfo,
} from 'reducers/setOutputReducer'
import { openModal } from 'reducers/messageReducer'
import {initMCBQS040Api,createApi} from 'apis/MCBQS040Api'
import { selectInitInfo,setInitResult,creatEventResponsDto,setMCBQS040OpenFlg,setMCBQS050InitInfo,setMCBQS050OpenFlag} from 'reducers/setOutputReducer'
import { getMessage } from 'common/messageUtil'

//イベント発生条件:初期画面
function* selectSubmissionListSaga(
  action: ReturnType<typeof selectInitInfo>
) {
  try {
    // 検索処理
    const data = yield call(initMCBQS040Api, action.payload)
    // 検索結果取得
    yield put(setInitResult(data))
  } catch (error) {
    // 異常
    yield put(openModal(error.message))
  }
}

//イベント発生条件:ファイルを作成する
function* createPdfSaga(action: ReturnType<typeof creatListInfo>) {
  try {
    // 検索処理
    const data = yield call(createApi, action.payload.formData)
    if (data) {
        if(data.applactionLst && data.applactionLst.length >0){
            action.payload.setOpenDialog2(true)
            yield put(creatEventResponsDto(data))
        }else{
            //対象件数設定
            //【画面設計書_MCBQS050_PDFダウンロード（セット出力）（一括）】用
            yield put(setMCBQS040OpenFlg(false))
            yield put(setMCBQS050InitInfo(data.targetCount))
            yield put(setMCBQS050OpenFlag(true))
        }
    }
   
  } catch (error) {
    if (error && error.message) {
      const errorMsgArray =  error.message.split(',')
      yield put(openModal(getMessage(errorMsgArray[0], errorMsgArray.slice(1))))
    }
  }
}

export default function* setOutputSaga() {
  yield all([
    takeLeading(selectInitInfo, selectSubmissionListSaga),
    takeLeading(creatListInfo, createPdfSaga),
  ])
}
